import Dashboard from "views/Dashboard/Dashboard.jsx";

import devRoutes from "./dev.jsx";
import receiverRoutes from "./receiver.jsx";
import userRoutes from "./user.jsx";
import contentRoutes from "./content.jsx";
import adminRoutes from "./admin.jsx";
import customerRoutes from "./customer.jsx";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import Image from "@material-ui/icons/Image";

var dashRedirect = [
  { redirect: true, path: "/", pathTo: "/dashboard", name: "Dashboard" }
];

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: Dashboard
  },
  {
    roles: ["dev"],
    collapse: true,
    path: "-page",
    name: "Content Pages",
    state: "openPages",
    icon: Image,
    views: contentRoutes
  },
  {
    roles: ["dev"],
    collapse: true,
    path: "-user",
    name: "All Users",
    state: "openUser",
    icon: Image,
    views: userRoutes
  },
  {
    roles: ["receiver"],
    collapse: true,
    path: "-receiver",
    name: "Receivers",
    state: "openReceiver",
    icon: Image,
    views: receiverRoutes
  },
  {
    roles: ["customer"],
    collapse: true,
    path: "-customer",
    name: "Customers",
    state: "openCustomer",
    icon: Image,
    views: customerRoutes
  },
  {
    roles: ["admin"],
    collapse: true,
    path: "-admin",
    name: "Admin Users",
    state: "openAdmin",
    icon: Image,
    views: adminRoutes
  },    
].concat(devRoutes).concat(dashRedirect);

export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx